import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  template: `
    <h1 mat-dialog-title>
      {{ 'website_edit.dialog.label__delete' | translate }}
    </h1>
    <div mat-dialog-content>
      <p>
        {{ 'website_edit.dialog.confirmationDialog.message' | translate }}
      </p>
    </div>
    <div mat-dialog-actions class="button-container">
      <su-button
        skin="secondary"
        [label]="'website_edit.dialog.confirmationDialog.cancel' | translate"
        (click)="onCancel()">
      </su-button>
      <su-button
        skin="primary"
        [label]="'website_edit.dialog.confirmationDialog.confirm' | translate"
        (click)="onConfirm()">
      </su-button>
    </div>
  `,
  styleUrl: './confirmation-dialog.component.scss',
  standalone: false,
})
export class ConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
